<template>
  <form @submit.prevent="submit">
    <base-modal small target="addInvestmentStatement" title="Add Statement Item">
      <base-field label="Funding Round">
        <base-select v-model="payload.funding" :model="investment.rounds" placeholder="funding round" required />
      </base-field>
      <base-field addon-left-icon="calendar-alt" label="Date">
        <base-input v-model="payload.date" datepicker placeholder="date" required />
      </base-field>
      <base-field label="Type">
        <base-select
          v-model="payload.type"
          store="core.paymentTypes.entities"
          store-action="core/payment-types/all"
          store-text="description"
          placeholder="type"
          required />
      </base-field>
      <base-field addon-left-icon="pound-sign" label="Credit">
        <base-input v-model="payload.credit" numeric placeholder="credit" />
      </base-field>
      <base-field addon-left-icon="pound-sign" label="Debit">
        <base-input v-model="payload.debit" numeric placeholder="debit" />
      </base-field>
      <base-field addon-left-icon="pound-sign" label="Capital">
        <base-input v-model="payload.capital" numeric placeholder="capital" />
      </base-field>
      <base-field addon-left-icon="pound-sign" label="Interest Due">
        <base-input v-model="payload.interestDue" numeric placeholder="interest due" />
      </base-field>
      <template v-slot:footer>
        <base-button :loading="isCreatePending" secondary submit>
          Save
        </base-button>
      </template>
    </base-modal>
  </form>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  name: 'InvestmentStatementCreateModal',

  data: () => ({
    payload: {}
  }),

  created () {
    this.refresh()
  },

  computed: {
    ...mapGetters({
      schema: 'core/investment-statements/schema'
    }),

    ...mapState({
      investment: store => store.core.investments.entity,
      isCreatePending: store => store.core.investmentStatements.isCreatePending
    })
  },

  methods: {
    refresh () {
      this.payload = this.$_.clone(this.schema)
      this.payload.investment = this.investment._id
    },

    submit () {
      this.create(this.payload)
        .then(async item => {
          this.$emit('created', this.$_.cloneDeep(item))
          this.$flash.success('Statement item successfully added.')
          this.$modal.close('#addInvestmentStatement')

          this.refresh()
        })
        .catch(err => this.$flash.failure(err))
    },

    ...mapActions({
      create: 'core/investment-statements/push'
    })
  }
}
</script>
